import MemberOptions from "@components/popups/MemberOptions";
import Popups from "@components/popups/Popups";
import ApiProxy from "@ts/ApiProxy";
import { Common } from "./CommonTypes";
import ValueSelector, { ValueSelectorResult } from "../popups/ValueSelector";
import GS from "@root/ts/GlobalSetting";
import CartCookie from "../shared/CartCookie";
import page_list from "@/raw-page-list.json";
import ActivityPromote from "../ui/blocks/ActivityPromote";
import TextBubble from "../ui/TextBubble";

let $root: JQuery;
let $userIcon: JQuery;
let _isInit = false;

export default class Nav {
  static init() {
    $root = $('nav');
    _isInit = true;
    $userIcon = $root.find(".user-icon").on("click", (event) => {
      event.preventDefault();
      this.openMemberOptions();
    });

    $root.find(".btn-search").on("click", (event: Event) => {
      event.preventDefault();
      Popups.to("search-popup");
    });

    if ($("body").attr("page") === "login-redirect") {
      $root.attr("state", "login-redirect");
    } else if ($("body").attr("page") === "about-supplier") {
      $root.attr("state", "supplier");
    } else {
      let data: Common.CommonPageData = ApiProxy.getCommonPageData();
      if (data.login_state.is_login) {
        $root.attr("state", "member");
        let info = data.login_state.info;
        (info.basic.picture) ? this.setUserPicture(info.basic.picture) : this.setUserPicture("./static/images/ui/avatar.png");
      } else {
        $root.attr("state", "public");
      }
      this.setupActivityPromote();
      if (data.login_state.is_login) {
        this.updateCartIcon(CartCookie.getNumCartItems());
        CartCookie.emitter.on("countChange", (num: number) => {
          this.updateCartIcon(num);
        });
      }
    }
    setupTestButton();
  }

  private static setupActivityPromote() {
    let pageData = ApiProxy.getCommonPageData();
    if (pageData.activity)
      ActivityPromote.generate(pageData.activity);
  }

  static showAddToCartHint(isUpdate: boolean) {
    let $btnCart = $root.find(".btn-cart");
    let text = isUpdate ? "購物車更新成功" : "已成功加入購物車";
    TextBubble.instance.popupAt($btnCart[0], text, { "icon": "checked", targetIsFixed: true });
  }

  static updateCartIcon(num: number) {
    let $count = $root.find(".btn-cart").find(".count");
    if (num > 9) {
      $count.css("display", "block").text("9+");
    } else if (num > 0) {
      $count.css("display", "block").text(num);
    } else {
      $count.css("display", "none");
    }
  }

  static setUserPicture(src: string, isNameOnly: boolean = false) {
    let $btn = $root.find(`.button.user-icon`);
    if (isNameOnly) {
      $btn.text(src);
    } else {
      let img = new Image();
      img.src = src;
      $btn.append(img);
    }
  }

  static openMemberOptions() {
    MemberOptions.instance.open($userIcon[0]);
  }

  static isInit() {
    return _isInit;
  }
}

function setupTestButton() {
  if (!GS.setting.testEnv) {
    $root.find(`.btn-test`).detach();
    return;
  }
  let rawPageList: any = page_list;
  rawPageList.unshift({
    "file-name": "login",
    "title": "登入",
    "type": "popup"
  });
  $root.find(`.btn-test`).on("click", (event: JQuery.ClickEvent) => {
    event.preventDefault();
    let valueList: any = [];
    rawPageList.forEach((obj: any) => {
      valueList.push({ text: obj["title"], value: obj });
    });
    ValueSelector.instance.show(valueList, null)
      .then((result?: ValueSelectorResult) => {
        if (result) {
          if (result.value.type === "popup") {
            Popups.to(result.value["file-name"]);
          } else {
            if (result.value.querys) {
              let list: any = [];
              result.value.querys.forEach((queryObj: any) => {
                let t = queryObj.title ? result.value.title + " - " + queryObj["title"] : result.value.title;
                list.push({ text: t, value: queryObj });
              });
              ValueSelector.instance.show(list, null)
                .then((nextResult?: ValueSelectorResult) => {
                  if (result) {
                    let q = nextResult.value.query;
                    if (q)
                      q = "?" + q;
                    window.location.href = result.value["file-name"] + ".html" + q;
                  }
                });
            } else
              window.location.href = result.value["file-name"] + ".html";
          }
        }
      });
  });
}